import { render, staticRenderFns } from "./CompanyInfo_BusinessType.vue?vue&type=template&id=58633455&scoped=true"
import script from "./CompanyInfo_BusinessType.vue?vue&type=script&lang=js"
export * from "./CompanyInfo_BusinessType.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo_BusinessType.vue?vue&type=style&index=0&id=58633455&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58633455",
  null
  
)

export default component.exports